export enum CarpetType {
  LANA = 'Lana o similar',
  PELUDO = 'peludo',
  LISO = 'liso',
}
